/* Two identical groups move exactly one group width per cycle. */
if (!customElements.get('vc-marquee')) {
  customElements.define('vc-marquee', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.vc-bar__track');
      this.group = this.querySelector('.vc-bar__group');
      this.original = this.group?.firstElementChild?.cloneNode(true);
      if (!this.original) return;
      this.refresh = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.build());
      };
      this.motionPreference = matchMedia('(prefers-reduced-motion: reduce)');
      this.motionPreference.addEventListener('change', this.refresh);
      this.observer = new ResizeObserver(this.refresh);
      this.observer.observe(this);
      this.refresh();
      document.fonts?.ready.then(() => { if (this.isConnected) this.refresh(); });
    }

    build() {
      this.removeAttribute('data-ready');
      this.track.querySelectorAll('[data-copy]').forEach(copy => copy.remove());
      this.group.replaceChildren(this.original.cloneNode(true));
      const itemWidth = this.group.getBoundingClientRect().width;
      if (!itemWidth || !this.clientWidth) return;
      const count = Math.max(1, Math.ceil(this.clientWidth / itemWidth));
      for (let i = 1; i < count; i++) this.group.append(this.original.cloneNode(true));
      const distance = this.group.getBoundingClientRect().width;
      const copy = this.group.cloneNode(true);
      copy.setAttribute('data-copy', '');
      this.track.append(copy);
      const speed = Number(this.dataset.speed) || 60;
      this.style.setProperty('--vc-marquee-duration', `${distance / speed}s`);
      this.setAttribute('data-ready', '');
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.motionPreference?.removeEventListener('change', this.refresh);
      cancelAnimationFrame(this.frame);
    }
  });
}
